// removed by extract-text-webpack-plugin
module.exports = {"link-button":"_3tUONYkup _1jY4uEptA _1yJuXbiru _3QqAd54bs _1yThnDgzj _3lg2nOgSZ _3R_kicQee _3FDZP6-k- _3kvYUMIJc _1s6tZE1os","is-disabled":"_CXVgLYBq _3fZBlRllO _3LTsSd03Q vEGfQgAxO"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/link-button/link-button.css
 ** module id = 2138
 ** module chunks = 0
 **/